<template>
  <DBox
    :id="'cmp-distribution-statement-sidewindow-catalog'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="'Upload Data'"
    @menuClick="onMenuClick"
    :rightMenu="[
      {
        text: $t('proceed_import'),
        value: 'proceed_import',
        class: isDisabled,
      },
    ]"
    @add_click="onAdd"
  >
    <div
      class="ut-fh ut-fc"
      :style="{
        overflowX: 'auto',
        width: `${widthH}px`,
      }"
    >
      <NTable
        v-if="
          selectedStatementDetails &&
          selectedStatementDetails.file &&
          selectedStatementDetails.file.imported_data &&
          selectedStatementDetails.file.imported_data.length > 0
        "
        id="contacts-contacts-contact_sidewindow-invoice_list"
        class="h1"
        :headers="headers"
        :items="list"
        :config="tableConfig"
      >
        <template v-slot:thead="{ thcon }">
          <tr>
            <th
              v-for="header in headers"
              v-bind="thcon(header.value)"
              :key="header.value"
            >
              <Dropdown2
                v-if="!isDSSEnabled"
                class="dbox1"
                :showLabel="false"
                :disabled="false"
                :options="columnNameTV"
                :placeholder="$t('')"
                v-on:selectedChange="(e) => onDropdownChange(header, e)"
                deselect
                :bb="'0px'"
                :selected="
                  columnNameTV.find(
                    (e) => e.value == finalColumnNames[header.value]
                  )
                "
              />
            </th>
          </tr>
        </template>
        <template v-slot:item="{ item, tdcon, index }">
          <tr>
            <td
              v-for="(x, ci) in item"
              v-bind="tdcon(ci)"
              :key="`${index}_${ci}_${x}`"
            >
              <span>{{ x }}</span>
            </td>
          </tr>
        </template>
      </NTable>
    </div>
  </DBox>
</template>

<script>
import NTable from "../../../../plugins/datatable/datatable";
import {
  createTableHeader,
  createNTableConfig,
} from "../../../../plugins/datatable";
import DBox from "@dtplugins/dbox/dbox";
import { DistributionStatementService } from "../../services/statement.service";
import { DistributionStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import { mapGetterObject, mapActionObject } from "../../../../store/global";
import { distributionStatementsGetters } from "../../store/statement/getters";
import { distributionStatementsActions } from "../../store/statement/actions";
import {
  ConfirmationService,
  createConfirmResult,
} from "../../../../dt-plugins/confirmation/confirmation.service";
import {
  confirmDelete,
  confirmMessage,
  confirmOK,
  okMessage,
} from "../../../../dt-plugins/confirmation/confirmation-common";
import { head } from "ramda";
import { DistributionImportsService } from "../../services/imports.service";
export default {
  components: {
    NTable,
    DBox,
  },
  props: {
    selectedStatementDetails: {
      type: Object,
    },
  },
  data: function () {
    return {
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
      }),
      column_names: [...Array(100).keys()].map((e) => ""),
    };
  },
  mounted: async function () {
    // this.column_names = [...this.selected_columns]
    // console.log(this.selected_columns,"this.column_names" ,this.column_names)
  },
  // watch: {
  //   selected_columns: {
  //     immediate: true,
  //     handler: function(newVal, oldVal) {
  //       console.log({newVal, oldVal})
  //        this.column_names = [...newVal]

  //     }
  //   }
  // },
  computed: {
    ...mapGetterObject(storeNS, distributionStatementsGetters),
    isDSSEnabled() {
      console.log({
        "this.selectedStatementDetails?.dss_id":
          this.selectedStatementDetails?.dss_id,
      });
      return this.selectedStatementDetails?.dss_id > 0;
    },
    widthH: function () {
      return this.headers.length * 180;
    },
    selected_columns: function () {
      return this.selectedStatementDetails.selected_columns || [];
    },
    finalColumnNames: function () {
      const onlyContainsEmptyString = this.column_names.reduce((accum, cur) => {
        if (cur != "") {
          accum = false;
        }
        return accum;
      }, true);

      if (this.selected_columns?.length > 0 && onlyContainsEmptyString) {
        this.column_names = [...this.selected_columns];
      }
      return this.column_names;
    },
    headers: function () {
      return [
        ...Array(
          (Math.max(
            ...(this.selectedStatementDetails?.file?.imported_data?.map(
              (e) => e?.length
            ) || [])
          ) || 0) > 0
            ? Math.max(
                ...(this.selectedStatementDetails?.file?.imported_data?.map(
                  (e) => e?.length
                ) || [])
              ) || 0
            : 0
        ).keys(),
      ].map((_, i) => createTableHeader(i, { text: false, ta: "left" }));
    },
    list: function () {
      return (
        this.selectedStatementDetails?.file?.imported_data
          ?.map((e) => {
            return e.map((x) => {
              if (x == null) {
                x = "";
              }
              return x;
            });
          })
          .map((e) => {
            return [
              ...e,
              ...[
                ...Array(
                  this.headers.length > e?.length
                    ? this.headers.length - e?.length
                    : 0
                ).keys(),
              ].map((e) => ""),
            ];
          }) || []
      );
    },

    isDisabled: function () {
      if (this.list.length > 0) {
        return "";
      } else {
        return "disabled";
      }
    },
    currentChannel: function () {
      return this.selectedStatementDetails?.stmt?.digital_physical;
    },

    columnNameTV: function () {
      let import_columns = {
        digital: [
          { value: "ds_isrc", text: this.$t("ds_isrc") },
          { value: "ds_barcode", text: this.$t("ds_barcode") },
          { value: "ds_identifier", text: this.$t("ds_identifier") },
          { value: "ds_artist", text: this.$t("ds_artist") },
          { value: "ds_title", text: this.$t("ds_title") },
          { value: "ds_version", text: this.$t("ds_version") },
          { value: "ds_album_title", text: this.$t("ds_album_title") },
          { value: "ds_catalog_no", text: this.$t("ds_catalog_no") },
          { value: "ds_bundle_track", text: this.$t("ds_bundle_track") },
          { value: "ds_usage_type", text: this.$t("ds_usage_type") },
          { value: "ds_offer_type", text: this.$t("ds_offer_type") },
          { value: "ds_country", text: this.$t("ds_country") },
          { value: "ds_shop", text: this.$t("ds_shop") },
          { value: "ds_info", text: this.$t("ds_info") },
          { value: "ds_sales", text: this.$t("ds_sales") },
          { value: "si_currency", text: this.$t("si_currency") },
          { value: "si_currency_amount", text: this.$t("si_currency_amount") },
          {
            value: "ds_return_identifier",
            text: this.$t("ds_return_identifier"),
          },
          { value: "ds_ppu", text: this.$t("ds_ppu") },
          { value: "ds_ppu_total", text: this.$t("ds_ppu_total") },
          { value: "ds_ppd", text: this.$t("ds_ppd") },
          { value: "ds_ppd_total", text: this.$t("ds_ppd_total") },
          { value: "ds_mechanicals", text: this.$t("ds_mechanicals") },
          {
            value: "ds_mechanical_total",
            text: this.$t("ds_mechanical_total"),
          },
          {
            value: "ds_product_identifier",
            text: this.$t("ds_product_identifier"),
          },
          { value: "performance_date", text: this.$t("performance_date") },
          { value: "si_label", text: this.$t("si_label") },
          { value: "delete_if_empty", text: this.$t("delete_if_empty") },
        ],
        physical: [
          { value: "ps_identifier", text: this.$t("ps_identifier") },
          { value: "ps_identifier_2nd", text: this.$t("ps_identifier_2nd") },
          { value: "ps_artist", text: this.$t("ps_artist") },
          { value: "ps_title", text: this.$t("ps_title") },
          { value: "ps_catalog_no", text: this.$t("ps_catalog_no") },
          { value: "ps_format", text: this.$t("ps_format") },
          { value: "ps_info", text: this.$t("ps_info") },
          { value: "ps_country", text: this.$t("ps_country") },
          { value: "ps_shop", text: this.$t("ps_shop") },
          { value: "ps_deduction", text: this.$t("ps_deduction") },
          {
            value: "ps_return_identifier",
            text: this.$t("ps_return_identifier"),
          },
          { value: "ps_net_sales", text: this.$t("ps_net_sales") },
          { value: "ps_ppu", text: this.$t("ps_ppu") },
          { value: "ps_ppu_total", text: this.$t("ps_ppu_total") },
          { value: "ps_ppd", text: this.$t("ps_ppd") },
          { value: "ps_ppd_total", text: this.$t("ps_ppd_total") },
          { value: "ps_sales", text: this.$t("ps_sales") },
          { value: "si_currency", text: this.$t("si_currency") },
          { value: "si_currency_amount", text: this.$t("si_currency_amount") },
          { value: "ps_ppu_sales", text: this.$t("ps_ppu_sales") },
          { value: "ps_ppu_total_sales", text: this.$t("ps_ppu_total_sales") },
          { value: "ps_ppd_sales", text: this.$t("ps_ppd_sales") },
          { value: "ps_ppd_total_sales", text: this.$t("ps_ppd_total_sales") },
          { value: "ps_pricelist", text: this.$t("ps_pricelist") },
          { value: "ps_returns", text: this.$t("ps_returns") },
          { value: "ps_defect_returns", text: this.$t("ps_defect_returns") },
          { value: "ps_ppu_returns", text: this.$t("ps_ppu_returns") },
          {
            value: "ps_ppu_total_returns",
            text: this.$t("ps_ppu_total_returns"),
          },
          { value: "ps_ppd_returns", text: this.$t("ps_ppd_returns") },
          {
            value: "ps_ppd_total_returns",
            text: this.$t("ps_ppd_total_returns"),
          },
          { value: "ps_defects", text: this.$t("ps_defects") },
          { value: "ps_promo", text: this.$t("ps_promo") },
          { value: "ps_foc", text: this.$t("ps_foc") },
          { value: "ps_foc_returns", text: this.$t("ps_foc_returns") },
          { value: "ps_adjustments", text: this.$t("ps_adjustments") },
          {
            value: "ps_cost_description",
            text: this.$t("ps_cost_description"),
          },
          { value: "ps_cost_group", text: this.$t("ps_cost_group") },
          { value: "ps_cost_amount", text: this.$t("ps_cost_amount") },
          { value: "ps_credit_amount", text: this.$t("ps_credit_amount") },
          {
            value: "ps_mechanical_total",
            text: this.$t("ps_mechanical_total"),
          },
          { value: "performance_date", text: this.$t("performance_date") },
          { value: "si_label", text: this.$t("si_label") },
          { value: "delete_if_empty", text: this.$t("delete_if_empty") },
        ],
        thirdparty: [
          { value: "ds_artist", text: this.$t("ds_artist") },
          { value: "ds_title", text: this.$t("ds_title") },
          { value: "ds_version", text: this.$t("ds_version") },
          { value: "ds_isrc", text: this.$t("ds_isrc") },
          { value: "ds_catalog_no", text: this.$t("ds_catalog_no") },
          {
            value: "ds_product_identifier",
            text: this.$t("ds_product_identifier"),
          },
          { value: "ds_ppd", text: this.$t("ds_ppd") },
          { value: "ds_usage_type", text: this.$t("ds_usage_type") },
          { value: "ds_country", text: this.$t("ds_country") },
          { value: "ds_shop", text: this.$t("ds_shop") },
          { value: "ds_info", text: this.$t("ds_info") },
          { value: "performance_date", text: this.$t("performance_date") },
          { value: "si_label", text: this.$t("si_label") },
          { value: "delete_if_empty", text: this.$t("delete_if_empty") },
        ],
        performance: [
          { value: "ds_artist", text: this.$t("ds_artist") },
          { value: "ds_title", text: this.$t("ds_title") },
          { value: "ds_version", text: this.$t("ds_version") },
          { value: "ds_isrc", text: this.$t("ds_isrc") },
          { value: "ds_catalog_no", text: this.$t("ds_catalog_no") },
          {
            value: "ds_product_identifier",
            text: this.$t("ds_product_identifier"),
          },
          { value: "perf_ppd", text: this.$t("perf_ppd") },
          { value: "ds_usage_type", text: this.$t("ds_usage_type") },
          { value: "ds_country", text: this.$t("ds_country") },
          { value: "ds_shop", text: this.$t("ds_shop") },
          { value: "ds_info", text: this.$t("ds_info") },
          { value: "performance_date", text: this.$t("performance_date") },
          { value: "si_currency", text: this.$t("si_currency") },
          { value: "si_currency_amount", text: this.$t("si_currency_amount") },
          { value: "si_label", text: this.$t("si_label") },
          { value: "delete_if_empty", text: this.$t("delete_if_empty") },
        ],
        multi: [
          { value: "ds_isrc", text: this.$t("ds_isrc") },
          { value: "ds_barcode", text: this.$t("ds_barcode") },
          { value: "ds_identifier", text: this.$t("ds_identifier") },
          { value: "ds_artist", text: this.$t("ds_artist") },
          { value: "ds_title", text: this.$t("ds_title") },
          { value: "ds_version", text: this.$t("ds_version") },
          { value: "ds_album_title", text: this.$t("ds_album_title") },
          { value: "ds_catalog_no", text: this.$t("ds_catalog_no") },
          { value: "ds_bundle_track", text: this.$t("ds_bundle_track") },
          { value: "ds_usage_type", text: this.$t("ds_usage_type") },
          { value: "ds_country", text: this.$t("ds_country") },
          { value: "ds_shop", text: this.$t("ds_shop") },
          { value: "ds_info", text: this.$t("ds_info") },
          { value: "ds_sales", text: this.$t("ds_sales") },
          { value: "si_currency", text: this.$t("si_currency") },
          { value: "si_currency_amount", text: this.$t("si_currency_amount") },
          {
            value: "ds_return_identifier",
            text: this.$t("ds_return_identifier"),
          },
          { value: "ds_ppu", text: this.$t("ds_ppu") },
          { value: "ds_ppu_total", text: this.$t("ds_ppu_total") },
          { value: "ds_ppd", text: this.$t("ds_ppd") },
          { value: "ds_ppd_total", text: this.$t("ds_ppd_total") },
          { value: "ds_mechanicals", text: this.$t("ds_mechanicals") },
          {
            value: "ds_mechanical_total",
            text: this.$t("ds_mechanical_total"),
          },
          {
            value: "ds_product_identifier",
            text: this.$t("ds_product_identifier"),
          },
          { value: "performance_date", text: this.$t("performance_date") },
          { value: "si_label", text: this.$t("si_label") },
          { value: "delete_if_empty", text: this.$t("delete_if_empty") },
        ],
        costs: [
          { value: "costs_identifier", text: this.$t("costs_identifier") },
          { value: "costs_artist", text: this.$t("costs_artist") },
          { value: "costs_title", text: this.$t("costs_title") },
          { value: "costs_group", text: this.$t("costs_group") },
          { value: "costs_description", text: this.$t("costs_description") },
          { value: "costs_amount", text: this.$t("costs_amount") },
          { value: "costs_company", text: this.$t("costs_company") },
          { value: "costs_reference_no", text: this.$t("costs_reference_no") },
          {
            value: "costs_identifier_2nd",
            text: this.$t("costs_identifier_2nd"),
          },
          { value: "costs_catalog_no", text: this.$t("costs_catalog_no") },
          { value: "costs_format", text: this.$t("costs_format") },
          { value: "costs_system_date", text: this.$t("costs_system_date") },
          {
            value: "costs_accounting_date",
            text: this.$t("costs_accounting_date"),
          },
          { value: "costs_payment_date", text: this.$t("costs_payment_date") },
          { value: "si_label", text: this.$t("si_label") },
          { value: "costs_currency", text: this.$t("costs_currency") },
          { value: "costs_cr_amount", text: this.$t("costs_cr_amount") },
        ],
        income: [
          { value: "costs_identifier", text: this.$t("costs_identifier") },
          { value: "costs_artist", text: this.$t("costs_artist") },
          { value: "costs_title", text: this.$t("costs_title") },
          { value: "costs_group", text: this.$t("costs_group") },
          { value: "costs_description", text: this.$t("costs_description") },
          { value: "costs_amount", text: this.$t("costs_amount") },
          { value: "costs_company", text: this.$t("costs_company") },
          { value: "costs_reference_no", text: this.$t("costs_reference_no") },
          {
            value: "costs_identifier_2nd",
            text: this.$t("costs_identifier_2nd"),
          },
          { value: "costs_catalog_no", text: this.$t("costs_catalog_no") },
          { value: "costs_format", text: this.$t("costs_format") },
          { value: "costs_system_date", text: this.$t("costs_system_date") },
          {
            value: "costs_accounting_date",
            text: this.$t("costs_accounting_date"),
          },
          { value: "costs_payment_date", text: this.$t("costs_payment_date") },
          { value: "si_label", text: this.$t("si_label") },
          { value: "costs_currency", text: this.$t("costs_currency") },
          { value: "costs_cr_amount", text: this.$t("costs_cr_amount") },
        ],
      };

      // Object.keys(import_columns).forEach(function(key, index) {
      //   import_columns[key] = import_columns[key].map(e=>{
      //     console.log(this,"::::::::")
      //     return{
      //       value:e['value'],
      //       text:this.$t( e['value'])
      //     }
      //   });
      // });

      const key = this.currentChannel;

      const colArray = import_columns[key];

      // const tvArray =  this.selectedStatementDetails?.column_names.map((e,i)=>{
      //   return {
      //     text:this.$t(e.value),
      //     value:e.value
      //   }
      // })
      return colArray || [];
    },
    file_type() {
      return (
        this.selectedStatementDetails?.file?.file_type ||
        head(this.selectedStatementDetails?.files)?.file_type ||
        "csv"
      );
    },
  },
  methods: {
    ...mapActionObject(storeNS, distributionStatementsActions),
    hasDuplicates: function () {
      let valuesSoFar = Object.create(null);
      for (let i = 0; i < this.column_names.length; ++i) {
        var value = this.column_names[i];
        console.log(value, '{:""""""""""}');
        if (value && value != "" && value in valuesSoFar) {
          return { hasDuplicates: true, value: value };
        }
        valuesSoFar[value] = true;
      }
      return { hasDuplicates: false, value: value };
    },

    processColumn: function () {
      const lengthDiff = this.column_names.length - this.headers.length;
      const indexToClean = this.column_names.length - lengthDiff;
      if (lengthDiff > 0) {
        console.log(
          "HEADER LENGTH:",
          indexToClean,
          "COLUMNS:",
          this.column_names
        );

        this.column_names = this.column_names?.map((element, i) => {
          if (i >= indexToClean) {
            return "";
          } else {
            return element;
          }
        });

        console.log("AFTER COLUMNS:", this.column_names);
      }
    },

    onAdd: function () {
      this.$emit("upload_click");
    },
    onDropdownChange: function (header, e) {
      //console.log(header.value,this.column_names[header.value],"::::::::::::",e.value)
      // this.column_names[header.value] = e.value;

      this.column_names = this.column_names?.map((element, i) => {
        if (i == header.value) {
          return e.value;
        } else {
          return element;
        }
      });
      this[ActionTypes.SET_SELECTED_COLUMNS]({
        statement_id: this.selectedStatementDetails.statement.statement_id,
        selected_columns: this.column_names,
      });

      console.log("this.column_names", this.column_names);
    },
    onMenuClick: async function (payload) {
      console.log(
        "selectedStatementDetails",
        this.selectedStatementDetails.statement
      );
      const date = new Date();

      const objStatement = this.selectedStatementDetails.statement;
      let objToPost = {
        column_names: JSON.stringify(this.column_names),
        uploaded_time: Math.floor(date.getTime() / 1000),
        statement_id: objStatement.statement_id,
        file_type: this.file_type,
      };
      const statementProperty = {
        fix_shop: objStatement?.fix_shop || "",
        fix_country: objStatement?.fix_country || "",
        fix_digital_type: objStatement?.fix_digital_type || "",
        return_identifier: objStatement?.return_identifier || "",
        distribution_fee_returns: objStatement?.distribution_fee_returns || "",
        distribution_fee_sales: objStatement?.distribution_fee_sales || "",
        return_handling_fee: objStatement?.return_handling_fee || "",
        returns_have_leading_minus:
          objStatement?.returns_have_leading_minus || "0",
      };
      if (this.currentChannel == "costs" || this.currentChannel == "income") {
        objToPost = { ...objToPost, action: "import_cost_statement" };
      } else {
        objToPost = {
          ...objToPost,
          action: "import_statement",
          ...statementProperty,
        };
      }
      switch (payload) {
        case "proceed_import": {
          if (this.isDSSEnabled) {
            // process_statement

            DistributionStatementService.processStatement(
              this.selectedStatementDetails.statement.statement_id,
              this.file_type
            );
            this.showNoticeAndGoBack(-3);
            return;
          }

          // waiting_process
          // import_statement

          this.processColumn();
          const duplicateCheck = this.hasDuplicates();
          console.log(duplicateCheck, '{":::::::::::"}');
          if (duplicateCheck.hasDuplicates) {
            const confirmationResult = await okMessage(
              this.$t(
                `You used the following headers multiple times:\n${this.$t(
                  duplicateCheck.value
                )}`
              )
            );
            break;
          }
          try {
            const { domain_tld } = window.HttpClient.getBaseURLObject();
            console.log({ domain_tld });
            await DistributionStatementService.waitingProcess();
            await DistributionStatementService.importStatement(
              {
                ...objToPost,
              },
              domain_tld
            );
          } catch (e) {
            console.log("EXCEPTION", e);
            //await confirmError(this.$t("Error occurred while importing statement"));
          } finally {
            this.showNoticeAndGoBack();
          }

          break;
        }
        case "load_preset_btn": {
          this.$emit("tab_click", "load_preset_btn");
          break;
        }
        case "btn_save_conf": {
          this.$emit("tab_click", "btn_save_conf");
          break;
        }
      }
    },
    async showNoticeAndGoBack(level = -2) {
      const confirmationResult = await okMessage(
        this.$t(
          "Your upload is being processed. You will be notified when your process is completed"
        ),
        "NOTICE"
      );

      if (confirmationResult === "ok") {
        this.$emit("close");
        this.$router.go(level);
      }
    },
  },
};
</script>

<style lang="scss"></style>


